import React, { useState } from 'react';

import { debounce } from 'lodash';

import { ChipLoader } from 'components/v2';

import { useDialogContext } from 'core/FiltersDialog/FiltersDialogContext';
import FiltersSelectHeader from '../FiltersSelectHeader';

import FilterFaxTypeData from './FilterFaxTypeData';
import { useFaxDocumentCategoryPagination } from './useFaxDocumentCategoryPagination';

interface FilterFaxTypeProps {
  type?: string;
  showHiddenResources?: boolean;
}

const FilterFaxType: React.FC<FilterFaxTypeProps> = ({ type = 'faxDocumentCategory', showHiddenResources }) => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const { handleSetCustomCount } = useDialogContext();

  const { isLoading, hasNextPage, fetchNextPage, allItems } = useFaxDocumentCategoryPagination(
    {
      limit: 20,
      _sort: 'name:asc',
      name: searchQuery ? `${searchQuery}*` : undefined,
    },
    {
      onSuccess: (data) => {
        const totalItemsFetched = data.pages.reduce((acc, page) => acc + page.response.length, 0);
        handleSetCustomCount(type, totalItemsFetched);
      },
    },
  );

  const handleOnSearchChange = (search: string) => setSearchQuery(search);

  return (
    <React.Fragment>
      <FiltersSelectHeader type={type} onSearchChange={debounce(handleOnSearchChange, 600)} items={allItems} />
      <FilterFaxTypeData type={type} queryObject={{ allItems, isLoading, hasNextPage, fetchNextPage }} />
    </React.Fragment>
  );
};

export default (props: any) => (
  <React.Suspense fallback={<ChipLoader />}>
    <FilterFaxType {...props} />
  </React.Suspense>
);
